import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/common/Navbar";
import Footer from "./components/common/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Awards from "./pages/Awards";
import Products from "./pages/Products";
import Sustainability from "./pages/Sustainability";
import Partners from "./pages/Partners";
import NotFound from "./pages/NotFound"; // Import the NotFound component
import "./App.css";
import UnderConstruction from "./pages/UnderConstruction";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<UnderConstruction />} />
        <Route path="/awards" element={<UnderConstruction />} />
        <Route path="/sustainable-csr" element={<UnderConstruction />} />
        <Route path="/partners" element={<UnderConstruction />} />
        <Route path="/products" element={<UnderConstruction />} />
        <Route path="*" element={<NotFound />} /> {/* Catch-all route */}
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
